export async function delay(delayMs: number) {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, delayMs);
    });
}

export async function doAsync(action: () => void | Promise<void>) {
    return new Promise((resolve, reject) => {
        requestAnimationFrame(() => {
            Promise.resolve(action()).then(resolve, reject);
        });
    });
}

export async function waitFrame() {
    return new Promise<void>((resolve) => {
        requestAnimationFrame(() => resolve());
    });
}

export async function waitFrames(frames: number) {
    // we wait at least one frame
    frames = Math.max(frames, 1);
    while (frames > 0) {
        await waitFrame();
        frames--;
    }
}

const AsyncUtil = {
    delay,
    doAsync,
    waitFrame,
    waitFrames,
};

export default AsyncUtil;
